import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#00796b', // Teal
    },
    secondary: {
      main: '#0288d1', // Light Blue
    },
    background: {
      default: '#f4f6f8',
      paper: '#ffffff',
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#4db6ac', // Lighter Teal
    },
    secondary: {
      main: '#4fc3f7', // Lighter Blue
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
});
